// add product steps
export const PRODUCT_SELECT_STEP = 1
export const PRODUCT_DESIGN_STEP = 2
export const PRODUCT_EDITOR_STEP = 3



// WEBPACK FOOTER //
// ./src/products/add/constants.js